function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash';
import EventHub from 'gw-portals-tracking-js';

export default (function () {
    var payloadTransformers = [];
    var registry = {};
    var transformers = [];

    /**
     * A service allowing to wire various event adapters (such as Google Analytics or Segment.IO)
     * to events generated by the application using either a configuration
     * object or a simple DSL during the Angular's configure phase
     */
    var eventAdapter = {
        /**
         * Expects a configuration object in form of:
         *
         * {
         *   serviceName*:
         *     {
         *       handler*: {
         *         category: String,
         *         eventName: String,
         *         filter: Function,
         *        }
         *     }
         * }
         *
         * there may be many adapters, and every adapter can have multiple
         * handlers,
         *
         * all arguments to handler are optional, in case of an empty handler,
         * the adapter will subscribe to all events and categories without
         *
         * @param {Object} config
         * @returns {Object}
         */
        configure: function configure(config) {
            _.forEach(config, function (handlers, serviceName) {
                registry[serviceName] = registry[serviceName] || {};
                Object.assign(registry[serviceName], handlers);
            });
            return eventAdapter;
        },


        /*
         * Registers a handler for adapter optionally filtered by category,
         * eventName and a custom filter function
         */

        register: function register(_ref) {
            var handler = _ref.handler,
                category = _ref.category,
                eventName = _ref.eventName,
                filter = _ref.filter,
                serviceName = _ref.serviceName;

            if (!_.isString(serviceName) || !_.isString(handler)) {
                throw new Error('Either handler or serviceName are not strings. handler: ' + handler + ', serviceName: ' + serviceName);
            }
            eventAdapter.configure(_defineProperty({}, serviceName, _defineProperty({}, handler, {
                filter: filter,
                category: category || '*',
                eventName: eventName || '*'
            })));
            return eventAdapter;
        },
        transform: function transform(transformFn) {
            console.log('DEPRECATED - Please use registerFunctionalHandler instead!');
            payloadTransformers.push(transformFn);
        },
        registerTransformer: function registerTransformer(_ref2) {
            var source = _ref2.source,
                target = _ref2.target,
                transformer = _ref2.transformer;

            transformers.push({ source: source, target: target, transformer: transformer });
        },

        $get: ['$injector', 'applicationFeatures', function ($injector, applicationFeatures) {
            var hub = new EventHub();
            hub.eventTransformers = payloadTransformers;

            function loadAdapter(adapterName) {
                try {
                    return $injector.get(adapterName);
                } catch (error) {
                    if (error.message.match('Unknown provider')) {
                        throw new Error('Event provider for \'' + adapterName + '\' is not registered.' + (' Add a service called \'' + adapterName + '\'') + ' before configuring tracking');
                    }
                    throw error;
                }
            }

            function wireAdapter(adapterConf, serviceName) {
                function getAdapterName(nameOfService) {
                    return (applicationFeatures.tracking || {})[nameOfService];
                }

                function isEnabled(nameOfService) {
                    return !!getAdapterName(nameOfService);
                }

                if (!isEnabled(serviceName)) return;
                _.forEach(adapterConf, function (_ref3, handlerName) {
                    var filter = _ref3.filter,
                        category = _ref3.category,
                        eventName = _ref3.eventName;

                    var adapter = loadAdapter(getAdapterName(serviceName));

                    function consumer(event) {
                        if (filter && !filter(event)) return;
                        adapter[handlerName](event);
                    }

                    hub.subscribe(category, eventName, consumer);
                });
            }

            _.forEach(registry, wireAdapter);

            function wireTransformer(_ref4) {
                var source = _ref4.source,
                    target = _ref4.target,
                    transformer = _ref4.transformer;

                function publishToHub(payload) {
                    hub.publish(target.category, target.eventName, payload);
                }

                hub.subscribe(source.category, source.eventName, function (event) {
                    transformer(event.payload, publishToHub);
                });
            }

            transformers.forEach(wireTransformer);

            return hub;
        }]
    };
    return eventAdapter;
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/EventHubProvider.js
// module id = 906
// module chunks = 0